export default function Footer() {
  return (
    <footer
      className="mt-10 border-t border-subtle pt-6 text-center text-xs text-muted-brand"
      data-testid="wizard-footer"
    >
      <p className="max-w-2xl mx-auto leading-relaxed">
        Insurance is the subject matter of solicitation. Information collected is
        used solely for the purpose of policy issuance and shall not be shared
        without your consent.
      </p>
    </footer>
  );
}
